<!-- Desktop Header -->
<ion-row *ngIf="platform === platformEnum.desktop">
  <ion-col size="3.45" offset="0.95">
    <app-sortable-section-carets
      [displayText]="sortOptions.productName.displayText"
      [headerName]="sortOptions.productName.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.productName.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.25">
    <app-sortable-section-carets
      [displayText]="sortOptions.vendor.displayText"
      [headerName]="sortOptions.vendor.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.vendor.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.25">
    <app-sortable-section-carets
      [displayText]="sortOptions.brand.displayText"
      [headerName]="sortOptions.brand.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.brand.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.20">
    <app-sortable-section-carets
      [displayText]="sortOptions.productNumber.displayText"
      [headerName]="sortOptions.productNumber.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.productNumber.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.25">
    <app-sortable-section-carets
      [displayText]="sortOptions.manufacturerNumber.displayText"
      [headerName]="sortOptions.manufacturerNumber.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.manufacturerNumber.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.25">
    <app-sortable-section-carets
      [displayText]="sortOptions.packSize.displayText"
      [headerName]="sortOptions.packSize.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.packSize.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.20">
    <app-sortable-section-carets
      [displayText]="sortOptions.pricing.displayText"
      [headerName]="sortOptions.pricing.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.pricing.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
</ion-row>
<!-- Tablet Header -->
<ion-row *ngIf="platform === platformEnum.tablet">
  <ion-col size="4" offset="1.70">
    <app-sortable-section-carets
      [displayText]="sortOptions.productName.displayText"
      [headerName]="sortOptions.productName.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.productName.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.9">
    <app-sortable-section-carets
      [displayText]="sortOptions.vendor.displayText"
      [headerName]="sortOptions.vendor.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.vendor.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.9">
    <app-sortable-section-carets
      [displayText]="sortOptions.brand.displayText"
      [headerName]="sortOptions.brand.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.brand.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
  <ion-col size="1.5">
    <app-sortable-section-carets
      [displayText]="sortOptions.manufacturerNumber.displayText"
      [headerName]="sortOptions.manufacturerNumber.headerName"
      [selectedHeader]="sortOptions.selectedHeader"
      [sortDirection]="sortOptions.manufacturerNumber.sortDirection"
      (sortClickEmitter)="handleSortClick($event)"
    ></app-sortable-section-carets>
  </ion-col>
</ion-row>
